import React from "react";
import {epayLogoBase64, vivaLogoBase64} from "./print-constants";
import {isEmpty} from "../../../_helpers/commonFunctions";

const A5Template = ({templateData, doubleA5 = false, lang = "GR"}) => {
    const showWaterMark = templateData.MYDATAENVIRONMENT === "test";

    const transactionDetailsBlock = {
        border: "1px solid #555",
        padding: "8px",
        borderRadius: "8px",
        fontSize: "9px",
        overflow: "hidden",
        overflowWrap: "break-word",
        textAlign: "center",
        fontWeight: "500",
    }

    const balanceContainer = {
        width: "200px",
        fontSize: "10px",
        display: "flex",
        justifyContent: "space-between",
        border: "1px solid #555",
        borderRadius: "8px",
        padding: "2px",
        fontWeight: "bold",
        textAlign: "center",
    }

    const columnStyle = {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        minHeight: "40px",
        padding: '4px',
    }

    const t = {
        "GR": {
            "vatNumber": "Α.Φ.Μ.",
            "phone": "ΤΗΛ",
            "doy": "ΔΟΥ",
            "website": "Ηλεκ. Ιστοσελίδα",
            "branch": "Υποκατάστημα",
            "gemh": "ΓΕΜΗ",
            "documentType": "ΕΙΔΟΣ ΠΑΡΑΣΤΑΤΙΚΟΥ",
            "preNumber": "ΣΕΙΡΑ",
            "number": "ΑΡΙΘΜΟΣ",
            "date": "ΗΜΕΡΟΜΗΝΙΑ",
            "time": "ΩΡΑ",
            "fullname": "ΟΝΟΜΑΤΕΠΩΝΥΜΟ",
            "address": "ΔΙΕΥΘΥΝΣΗ",
            "paymentType": "ΤΡΟΠΟΣ ΠΛΗΡΩΜΗΣ",
            "paymentTypeShort": "ΤΡ. ΠΛΗΡΩΜΗΣ",
            "reverseDeliveryNote": "ΑΙΤΙΑ ΑΝΤΙΣΤΡΟΦΗΣ ΔΙΑΚΙΝΗΣΗΣ",
            "vatPaymentSuspension": "ΜΕ ΑΝΑΣΤΟΛΗ ΚΑΤΑΒΟΛΗΣ Φ.Π.Α.",
            "paymentHistory": "ΙΣΤΟΡΙΚΟ ΠΛΗΡΩΜΩΝ",
            "with": "ΜΕΣΩ",
            "amount": "ΠΟΣΟ",
            "tip": "ΦΙΛΟΔΩΡΗΜΑ",
            "providerSignature": "ΥΠΟΓΡΑΦΗ ΠΑΡΟΧΟΥ",
            "providerTransactionId": "ΜΟΝ. ΤΑΥΤ. ΠΛΗΡΩΜΗΣ",
            "paymentDate": "ΗΜΕΡΟΜΗΝΙΑ ΠΛΗΡΩΜΗΣ",
            "code": "ΚΩΔΙΚΟΣ",
            "description": "ΠΕΡΙΓΡΑΦΗ",
            "quantity": "ΠΟΣΟΤΗΤΑ",
            "unitPrice": "ΤΙΜΗ ΜΟΝΑΔΑΣ",
            "vatPercentage": "ΦΠΑ %",
            "discount": "ΕΚΠΤΩΣΗ",
            "priceBeforeVAT": "ΤΙΜΗ ΠΡΟ ΦΠΑ",
            "vatAmount": "ΑΞΙΑ ΦΠΑ",
            "fees": "ΦΟΡΟΙ/ΤΕΛΗ",
            "totalValue": "ΤΕΛΙΚΗ ΑΞΙΑ",
            "previousBalance": "Προηγ. Υπόλοιπο",
            "nextBalance": "Νέο Υπόλοιπο",
            "netValue": "Καθαρή Αξία",
            "vatValue": "Αξία ΦΠΑ",
            "feeValue": "Φόροι/Τέλη",
            "totalValue2": "Τελική Αξία",
            "vatReason": "ΑΠΑΛΛΑΓΗ ΑΠΟ ΤΟ Φ.Π.Α.",
            "notes": "ΠΑΡΑΤΗΡΗΣΕΙΣ",
            "totalQuantity": "ΣΥΝΟΛΟ ΤΕΜΑΧΙΩΝ",
            "totalWithoutVAT": "ΣΥΝΟΛΟ ΠΡΟ ΦΠΑ",
            "totalVAT": "Φ.Π.Α.",
            "totalTotalValue": "ΤΕΛΙΚΟ ΣΥΝΟΛΟ",
            "totalWithhold": "ΣΥΝΟΛΟ ΠΑΡΑΚΡΑΤΟΥΜΕΝΩΝ ΦΟΡΩΝ",
            "paymentAmount": "ΠΛΗΡΩΤΕΟ ΠΟΣΟ",
            "issue": "ΕΚΔΟΣΗ",
            "receipt": "ΠΑΡΑΛΑΒΗ",
            "nonTaxDocument": "Το παρόν ΔΕΝ αποτελεί φορολογικό παραστατικό",
            "page": "Σελίδα",
            "from": "από",
        },
        "EN": {
            "vatNumber": "VAT",
            "phone": "PHONE",
            "doy": "DOY",
            "website": "Website",
            "branch": "Installation",
            "gemh": "GEMH",
            "documentType": "DOCUMENT TYPE",
            "preNumber": "SERIES",
            "number": "NUMBER",
            "date": "DATE",
            "time": "TIME",
            "fullname": "FULL NAME",
            "address": "ADDRESS",
            "paymentType": "PAYMENT TYPE",
            "paymentTypeShort": "PAYMENT TYPE",
            "reverseDeliveryNote": "REVERSE DELIVERY NOTE REASON",
            "vatPaymentSuspension": "WITH VAT PAYMENT SUSPENSION",
            "paymentHistory": "PAYMENT HISTORY",
            "with": "WITH",
            "amount": "AMOUNT",
            "tip": "TIP",
            "providerSignature": "PROVIDER SIGNATURE",
            "providerTransactionId": "PROVIDER TRANSACTION ID",
            "paymentDate": "PAYMENT DATE",
            "code": "CODE",
            "description": "DESCRIPTION",
            "quantity": "QUANTITY",
            "unitPrice": "UNIT PRICE",
            "vatPercentage": "VAT %",
            "discount": "DISCOUNT",
            "priceBeforeVAT": "PRICE BEFORE VAT",
            "vatAmount": "VAT AMOUNT",
            "fees": "TAXES",
            "totalValue": "TOTAL VALUE",
            "previousBalance": "Previous Balance",
            "nextBalance": "New Balance",
            "netValue": "Net Value",
            "vatValue": "Vat Value",
            "feeValue": "Taxes",
            "totalValue2": "Total Value",
            "vatReason": "VAT EXCEPTION",
            "notes": "NOTES",
            "totalQuantity": "TOTAL QUANTITY",
            "totalWithoutVAT": "TOTAL WITHOUT VAT",
            "totalVAT": "VAT",
            "totalTotalValue": "TOTAL VALUE",
            "totalWithhold": "TOTAL WITHHELD",
            "paymentAmount": "PAYMENT AMOUNT",
            "issue": "ISSUANCE",
            "receipt": "RECEIPT",
            "nonTaxDocument": "This document is not a tax document",
            "page": "Page",
            "from": "from",
        }
    }[lang];

    const totalPagesA = templateData.TOTAL_PAGES !== undefined ? templateData.TOTAL_PAGES : [];

    const renderPage = (index, firstCopy = false) => {
        return (
            <React.Fragment>
                <div className="sales-print-template">
                    <div className="a5-receipt a5-invoice-box">
                        <div>
                            <div>{t.page}: {index + 1} {t.from} {totalPagesA.length}</div>
                            <table cellPadding="0" cellSpacing="0">
                                <tbody>
                                <tr className="top">
                                    <td>
                                        <table className="a5-header_table">
                                            <tbody>
                                            <tr>
                                                {templateData.BRANCH === "" && (
                                                    <td className="a5-issuer_container">
                                                        {templateData.ISSUER_NAME && templateData.ISSUER_NAME !== "" && <p><span className="a5-skin">{templateData.ISSUER_NAME}</span></p>}
                                                        {templateData.ISSUER_SMALL_NAME && templateData.ISSUER_SMALL_NAME !== "" && <p><span className="a5-skin">{templateData.ISSUER_SMALL_NAME}</span></p>}
                                                        {templateData.ISSUER_SUBJECTFIELD && templateData.ISSUER_SUBJECTFIELD !== "" && <p><span className="a5-skin">{templateData.ISSUER_SUBJECTFIELD}</span></p>}
                                                        {templateData.ISSUER_ADDRESS && templateData.ISSUER_ADDRESS !== "" && <p><span className="a5-skin">{templateData.ISSUER_ADDRESS}, {templateData.ISSUER_CITY}, {templateData.ISSUER_TK}, {t.phone}: {templateData.ISSUER_PHONE}, {t.doy}: {templateData.ISSUER_DOY}</span></p>}
                                                        {templateData.ISSUER_VAT && templateData.ISSUER_VAT !== "" && <p><span className="a5-skin">{t.vatNumber}: {templateData.ISSUER_VAT}, {!isEmpty(templateData.ISSUER_GEMH) && `ΓΕΜΗ: ${templateData.ISSUER_GEMH}, `}{!isEmpty(templateData.ISSUER_AMKA) && `ΑΜΚΑ: ${templateData.ISSUER_AMKA}, `} EMAIL: {templateData.ISSUER_EMAIL}</span></p>}
                                                        {!isEmpty(templateData.ISSUER_WEBPAGE) && (
                                                            <p><span className="a5-skin">{t.website}: {templateData.ISSUER_WEBPAGE}</span></p>
                                                        )}
                                                    </td>
                                                )}
                                                {templateData.BRANCH !== "" && (
                                                    <td className="a5-issuer_container">
                                                        {templateData.ISSUER_NAME && templateData.ISSUER_NAME !== "" && <p><span className="a5-skin">{templateData.ISSUER_NAME}</span></p>}
                                                        {templateData.ISSUER_SMALL_NAME && templateData.ISSUER_SMALL_NAME !== "" && <p><span className="a5-skin">{templateData.ISSUER_SMALL_NAME}</span></p>}
                                                        {templateData.ISSUER_SUBJECTFIELD && templateData.ISSUER_SUBJECTFIELD !== "" && <p><span className="a5-skin">{templateData.ISSUER_SUBJECTFIELD}</span></p>}
                                                        {templateData.ISSUER_ADDRESS && templateData.ISSUER_ADDRESS !== "" && <p><span className="a5-skin">{t.branch}: {templateData.BRANCH?.address}, {templateData.BRANCH?.city}, {templateData.BRANCH?.postalCode}</span></p>}
                                                        {templateData.ISSUER_PHONE && templateData.ISSUER_PHONE !== "" && <p><span className="a5-skin">{t.phone}: {templateData.BRANCH?.phone}</span></p>}
                                                        {templateData.ISSUER_DOY && templateData.ISSUER_DOY !== "" && <p><span className="a5-skin">{t.doy}: {templateData.BRANCH?.doy}</span></p>}
                                                        {templateData.ISSUER_VAT && templateData.ISSUER_VAT !== "" && <p><span className="a5-skin">{t.vatNumber}: {templateData.ISSUER_VAT}</span></p>}
                                                        {templateData.ISSUER_GEMH && templateData.ISSUER_GEMH !== "" && <p><span className=" a5-skin">{t.gemh}: {templateData.ISSUER_GEMH}</span></p>}
                                                        {templateData.ISSUER_EMAIL && templateData.ISSUER_EMAIL !== "" && <p><span className="a5-skin">EMAIL: {templateData.ISSUER_EMAIL}</span></p>}
                                                        {!isEmpty(templateData.ISSUER_WEBPAGE) && (
                                                            <p><span className="a5-skin">{t.website}: {templateData.ISSUER_WEBPAGE}</span></p>
                                                        )}
                                                    </td>
                                                )}
                                            </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div className="a5-main_info">
                                <table cellPadding="0" cellSpacing="0">
                                    <tbody>
                                    <tr>
                                        <td>
                                            <table className="a5-main_info_table">
                                                <tbody>
                                                <tr className="a5-heading">
                                                    <td className="a5-p">{t.documentType}</td>
                                                    <td className="a5-p">{t.preNumber}</td>
                                                    <td className="a5-p">{t.number}</td>
                                                    <td className="a5-p">{t.date}</td>
                                                    <td className="a5-p">{t.time}</td>
                                                </tr>
                                                <tr>
                                                    <td><span>{templateData.INVOICE_TYPE ? templateData.INVOICE_TYPE : '-'}</span></td>
                                                    <td><span>{templateData.SERIES ? templateData.SERIES : '-'}</span></td>
                                                    <td><span>{templateData.NUMBER ? templateData.NUMBER : '-'}</span></td>
                                                    <td><span>{templateData.INVOICE_DATE ? templateData.INVOICE_DATE : '-'}</span></td>
                                                    <td><span>{templateData.INVOICE_TIME ? templateData.INVOICE_TIME : '-'}</span></td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <table className="a5-information_table" cellPadding="0" cellSpacing="0">
                                <tbody>
                                <tr>
                                    <td className="a5-information_td_left">
                                        <div className="a5-information left">
                                            <table className="a5-information_customer">
                                                <tbody>
                                                <tr>
                                                    <td className="a5-information_customer_td a5-skin a5-bold"><span> {t.fullname}</span></td>
                                                    <td className="a5-info_value"><span>: </span><span className="a5-counterparty_name">{templateData.CUSTOMER_NAME}</span></td>
                                                </tr>
                                                <tr>
                                                    <td className="a5-skin a5-bold"><span> EMAIL</span></td>
                                                    <td className="a5-info_value"><span>: </span><span className="a5-counterparty_name">{templateData.CUSTOMER_EMAIL}</span></td>
                                                </tr>
                                                <tr>
                                                    <td className="a5-skin a5-bold"><span> {t.address}</span></td>
                                                    <td className="a5-info_value"><span>: </span><span className="a5-counterparty_name">{templateData.CUSTOMER_ADDRESS}</span></td>
                                                </tr>
                                                <tr>
                                                    <td className="a5-skin a5-bold"><span> {t.paymentType}</span></td>
                                                    <td className="a5-info_value"><span>: </span><span className="a5-counterparty_name">{templateData.PAYMENT_METHOD}</span></td>
                                                </tr>
                                                {templateData.REVERSE_DELIVERY_NOTE_PURPOSE !== '' && (
                                                    <tr>
                                                        <td className="a5-skin a5-bold"><span> {t.reverseDeliveryNote}</span></td>
                                                        <td className="a5-info_value"><span>: </span><span className="a5-counterparty_name">{templateData.REVERSE_DELIVERY_NOTE_PURPOSE}</span></td>
                                                    </tr>
                                                )}
                                                {templateData.VAT_PAYMENT_SUSPENSION && (
                                                    <tr>
                                                        <td colSpan={2} className="a5-skin a5-bold"><span>{t.vatPaymentSuspension}</span></td>
                                                    </tr>
                                                )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                    <td></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        {(templateData?.PAGE_TYPES && templateData?.PAGE_TYPES.length > 0
                            && templateData.PAGE_TYPES.find((el) => el.index === index)?.type === "PAYMENT_HISTORY" && !templateData.TRANSACTION_DETAILS) ? (
                            <React.Fragment>
                                <div style={{
                                    textAlign: "center",
                                    fontSize: "14px",
                                    marginTop: "5px",
                                    marginBottom: "5px",
                                    color: "white",
                                    backgroundColor: "#555",
                                    fontWeight: "bold"
                                }}>{t.paymentHistory}</div>
                                <div style={{
                                    minHeight: "500px",
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "wrap"
                                }}>
                                    {templateData.PAYMENT_HISTORY[index].map((transDetails) => {
                                        if (transDetails.providerSignature) {
                                            return (
                                                <div style={{
                                                    ...transactionDetailsBlock,
                                                    width: "50%",
                                                    maxWidth: "50%",
                                                    flex: "50%",
                                                    height: "220px",
                                                    fontSize: "8px"
                                                }}>
                                                    {transDetails?.isEuronet === "true" && (
                                                        <React.Fragment>
                                                            <img style={{margin: "0", width: "20mm"}} className={"mb-2"}
                                                                 src={epayLogoBase64} alt={"ePay Logo"}/>
                                                            <br/>
                                                            <span style={{fontSize: "7px"}}>EURONET MERCHANT SERVICES A.E. GEMH: 159277401000</span>
                                                        </React.Fragment>
                                                    )}
                                                    {transDetails?.isEuronet === "viva" && (
                                                        <React.Fragment>
                                                            <img style={{margin: "0", width: "15mm"}} src={vivaLogoBase64} alt={"Viva Logo"}/>
                                                            <br/>
                                                        </React.Fragment>
                                                    )}
                                                    <table className={"transactionDetailsTable"}
                                                           style={{width: "100%", tableLayout: "fixed", fontSize: "8px"}}>
                                                        <tbody>
                                                        <tr>
                                                            <td>{t.paymentTypeShort}:</td>
                                                            <td>{transDetails?.PAYMENT_METHOD}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t.date}:</td>
                                                            <td>{transDetails?.transactionDate}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>TID/MID:</td>
                                                            <td>{transDetails?.terminalId} / {transDetails?.merchantId}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>ΑΡ.
                                                                ΣΥΝ.: {transDetails?.transactionNumber}</td>
                                                            <td>ΕΓΚΡΙΣΗ: {transDetails?.authorizationCode}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>RRN.:</td>
                                                            <td>{transDetails?.rnn}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t.with}:
                                                                {transDetails?.isEuronet === "true" && `EPAY`}
                                                                {transDetails?.isEuronet === "viva" && `VIVA`}
                                                            </td>
                                                            <td>{transDetails?.cardType} {transDetails?.aid} {transDetails?.panCard} - {transDetails?.finalCode}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t.amount}:</td>
                                                            <td>{transDetails?.amountTotalString} €</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t.tip}:</td>
                                                            <td>{transDetails?.tipAmountString} €</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t.providerSignature}:</td>
                                                            <td style={{wordBreak: "break-all", fontSize: "8px"}}>{transDetails?.providerSignature}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t.providerTransactionId}:</td>
                                                            <td>{transDetails?.providerTransactionId}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )
                                        } else {
                                            return (
                                                <div style={{
                                                    ...transactionDetailsBlock,
                                                    width: "50%",
                                                    maxWidth: "50%",
                                                    flex: "50%",
                                                    height: "220px",
                                                    fontSize: "10px"
                                                }}>
                                                    <table className={"transactionDetailsTable"}
                                                           style={{width: "100%", tableLayout: "fixed"}}>
                                                        <tbody>
                                                        <tr>
                                                            <td>{t.paymentType}</td>
                                                            <td>{transDetails?.paymentTypeName}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t.paymentDate}</td>
                                                            <td>{transDetails?.paymentDate}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t.amount}</td>
                                                            <td>{transDetails?.paymentAmount}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )
                                        }
                                    })}
                                </div>
                            </React.Fragment>
                        ) : (
                            <div className="a5-product_container">
                                <table className="a5-product_table" cellPadding="0" cellSpacing="0">
                                    <tbody>
                                    <tr className="a5-heading">
                                        <td className="a5-description_head_td a5-p">{t.code}</td>
                                        <td className="a5-description_head_td a5-p">{t.description}</td>
                                        <td className="a5-quantity_head_td a5-p">{t.quantity}</td>
                                        <td className="a5-up_head_td a5-p">{t.unitPrice}</td>
                                        <td className="a5-vat_head_td a5-p">{t.vatPercentage}</td>
                                        <td className="a5-pricenovat_head_td a5-p">{t.discount}</td>
                                        <td className="a5-pricenovat_head_td a5-p">{t.priceBeforeVAT}</td>
                                        <td className="a5-pricenovat_head_td a5-p">{t.vatAmount}</td>
                                        <td className="a5-whtax_head_td a5-p">{t.fees}</td>
                                        <td className="a5-price_head_td a5-p">{t.totalValue}</td>
                                    </tr>
                                    {templateData.PRODUCT_DETAILS && templateData.PRODUCT_DETAILS[index]?.length > 0 && templateData.PRODUCT_DETAILS[index].map((product) => (
                                        <tr className="a5-products" key={Math.random()}>
                                            <td><span className="a5-item_code">{product.CODE}</span></td>
                                            <td><span
                                                className="a5-item_description">{product.PRODUCT_DESCRIPTION}</span>
                                            </td>
                                            <td><span className="a5-item_quantity">{product.QTY}</span></td>
                                            <td><span className="a5-item_unit_price">{product.PRICE_QTY}</span></td>
                                            <td><span className="a5-item_vat">{product.VAT}{product?.DONT_SHOW_PERCENTAGE === true ? "" : "%"}</span></td>
                                            <td><span className="a5-item_discount">{product.DISCOUNT}</span></td>
                                            <td><span className="a5-item_price_no_vat">{product.PRICE_NOVAT}</span>
                                            </td>
                                            <td><span className="a5-item_vat_price">{product.VAT_PRICE}</span></td>
                                            <td><span className="a5-item_other_taxes">{product.OTHER_TAXES}</span>
                                            </td>
                                            <td><span className="a5-item_total_price">{product.TOTAL}</span></td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        <div className="a5-footer_container">
                            <table className="a5-footer_table" style={{tableLayout: "fixed", width: "100%"}}>
                                <colgroup>
                                    <col span={1}></col>
                                    <col span={1} style={{width: "150px"}}></col>
                                    <col span={1}></col>
                                    <col span={1}></col>
                                </colgroup>
                                <tbody>
                                <tr>
                                    <td>
                                        {(templateData.OLD_BALANCE && templateData.NEW_BALANCE && !templateData.ENABLE_PEPPOL) &&
                                            <div style={balanceContainer}>
                                                <div>
                                                    <div style={{margin: "auto"}}>{t.previousBalance}</div>
                                                    <div style={{margin: "auto", fontWeight: "normal"}}>{templateData.OLD_BALANCE}</div>
                                                </div>
                                                <div>
                                                    <div style={{margin: "auto"}}>{t.nextBalance}</div>
                                                    <div style={{margin: "auto", fontWeight: "normal"}}>{templateData.NEW_BALANCE}</div>
                                                </div>
                                            </div>
                                        }
                                        <div className="a5-per_vat_totals_container">
                                            <table>
                                                <tbody>
                                                <tr>
                                                    <th>{t.vatPercentage}</th>
                                                    <th>{t.netValue}</th>
                                                    <th>{t.vatValue}</th>
                                                    <th>{t.feeValue}</th>
                                                    <th>{t.totalValue2}</th>
                                                </tr>
                                                {(templateData.VAT_TABLE && index + 1 === totalPagesA.length && templateData.VAT_TABLE?.length > 0) && templateData.VAT_TABLE.map((taxes, idx) => (
                                                    <tr key={`a5-gr-taxes-${idx}`}>
                                                        <td>{taxes.TAX_PERCENT} {taxes.TAX_CODE ? `(${taxes.TAX_CODE})` : null}</td>
                                                        <td>{taxes.NET_VALUE}</td>
                                                        <td>{taxes.TAX_VALUE}</td>
                                                        <td>{taxes.OTHER_TAXES}</td>
                                                        <td>{taxes.TOTAL_VALUE}</td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="a5-cont_notation">
                                            {templateData.VATEXPCAT && templateData.VATEXPCAT?.length > 0 && templateData.VATEXPCAT.map((reason) => (
                                                <React.Fragment>
                                                    <span className="skin bold">{t.vatReason} :</span>
                                                    <div className="a5-cont_notation_inner">
                                                        <span>{reason.vat} {reason.description} <br/></span>
                                                    </div>
                                                </React.Fragment>
                                            ))}
                                            <span className="a5-skin a5-bold">{t.notes}:<br/> <span dangerouslySetInnerHTML={{__html: String(templateData?.INVOICE_NOTES).replaceAll("\n", "<br/>")}}></span></span>
                                        </div>
                                    </td>
                                    {((templateData?.UID !== "" && templateData.MYDATADESTINATION === "provider") || (templateData?.UID !== "" && templateData.MYDATADESTINATION !== "provider" && templateData.MYDATAQRURL)) && (
                                        <td>
                                            <div className={"d-flex justify-content-center"}>
                                                <img src={templateData?.QR_CODE} alt="QR Code" className="a5-product-qr-code-img" />
                                            </div>
                                        </td>
                                    )}
                                    {((templateData?.TRANSACTION_DETAILS && index + 1 === totalPagesA.length) && (
                                        <td>
                                            {(templateData?.TRANSACTION_DETAILS?.providerSignature) ? (
                                                <div style={{...transactionDetailsBlock, width: "100%", fontSize: "8px", minHeight: "120px"}}>
                                                    {templateData.TRANSACTION_DETAILS?.isEuronet === "true" && (
                                                        <React.Fragment>
                                                            <img style={{margin: "0", width: "20mm"}} className={"mb-2"}
                                                                 src={epayLogoBase64} alt={"ePay Logo"}/>
                                                            <br/>
                                                            <span style={{fontSize: "7px"}}>EURONET MERCHANT SERVICES A.E. GEMH: 159277401000</span>
                                                        </React.Fragment>
                                                    )}
                                                    {templateData.TRANSACTION_DETAILS?.isEuronet === "viva" && (
                                                        <React.Fragment>
                                                            <img style={{margin: "0", width: "15mm"}} src={vivaLogoBase64} alt={"Viva Logo"}/>
                                                            <br/>
                                                        </React.Fragment>
                                                    )}
                                                    <table className={"transactionDetailsTable"} style={{width: "100%", tableLayout: "fixed", fontSize: "8px"}} cellSpacing={0} cellPadding={0}>
                                                        <tbody>
                                                        <tr>
                                                            <td>{t.paymentTypeShort}</td>
                                                            <td>{templateData.TRANSACTION_DETAILS?.PAYMENT_METHOD}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t.date}</td>
                                                            <td>{templateData.TRANSACTION_DETAILS?.transactionDate}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>TID/MID:</td>
                                                            <td>{templateData.TRANSACTION_DETAILS?.terminalId} / {templateData.TRANSACTION_DETAILS?.merchantId}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>ΑΡ.
                                                                ΣΥΝ.: {templateData.TRANSACTION_DETAILS?.transactionNumber}</td>
                                                            <td>ΕΓΚΡΙΣΗ: {templateData.TRANSACTION_DETAILS?.authorizationCode}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>RRN.:</td>
                                                            <td>{templateData.TRANSACTION_DETAILS?.rnn}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t.with}:
                                                                {templateData.TRANSACTION_DETAILS?.isEuronet === "true" && `EPAY`}
                                                                {templateData.TRANSACTION_DETAILS?.isEuronet === "viva" && `VIVA`}
                                                            </td>
                                                            <td>{templateData.TRANSACTION_DETAILS?.cardType} {templateData.TRANSACTION_DETAILS?.aid} {templateData.TRANSACTION_DETAILS?.panCard} - {templateData.TRANSACTION_DETAILS?.finalCode}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t.amount}:</td>
                                                            <td>{templateData.TRANSACTION_DETAILS?.amountTotalString} €</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t.tip}:</td>
                                                            <td>{templateData.TRANSACTION_DETAILS?.tipAmountString} €</td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan={2} style={{wordBreak: "break-all", fontSize: "8px"}}>{t.providerSignature}: {templateData.TRANSACTION_DETAILS?.providerSignature}</td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan={2} style={{wordBreak: "break-all", fontSize: "8px"}}>{t.providerTransactionId}: {templateData.TRANSACTION_DETAILS?.providerTransactionId}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div style={{...transactionDetailsBlock, width: "100%", minHeight: "60px"}}>
                                                    <table className={"transactionDetailsTable"} style={{width: "100%", tableLayout: "fixed"}}>
                                                        <tbody>
                                                        <tr>
                                                            <td>{t.paymentType}</td>
                                                            <td>{templateData.TRANSACTION_DETAILS?.paymentTypeName}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t.paymentDate}</td>
                                                            <td>{templateData.TRANSACTION_DETAILS?.paymentDate}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t.amount}</td>
                                                            <td>{templateData.TRANSACTION_DETAILS?.paymentAmount}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}
                                        </td>
                                    ))}
                                    <td>
                                        <div className="a5-count_totals_container">
                                            <span>{t.totalQuantity}: </span> <span className="a5-count_total_prods"> {index + 1 === totalPagesA.length ? templateData.TOTAL_QTY : ''}</span>
                                        </div>
                                        <div className="a5-total_container">
                                            <div className="a5-totals">
                                                <table className="a5-totals_table">
                                                    <tbody>
                                                    <tr>
                                                        <td className="a5-text-left a5-p">{t.totalWithoutVAT}</td>
                                                        <td className="a5-text-right a5-p">
                                                            <span>{index + 1 === totalPagesA.length ? templateData.TOTAL_NOVAT : ''}</span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="a5-text-left a5-p">{t.totalVAT}</td>
                                                        <td className="a5-text-right a5-p">
                                                            <span>{index + 1 === totalPagesA.length ? templateData.TOTAL_VAT : ''}</span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="a5-text-left a5-p">{t.totalValue}</td>
                                                        <td className="a5-text-right a5-p">
                                                            <span>{index + 1 === totalPagesA.length ? templateData.TOTAL_PRICE : ''}</span>
                                                        </td>
                                                    </tr>
                                                    {templateData.TOTAL_WITHHOLD && (
                                                        <tr>
                                                            <td className="a5-text-left a5-p">{t.totalWithhold}</td>
                                                            <td className="a5-text-right a5-p">
                                                                <span>{index + 1 === totalPagesA.length ? templateData.TOTAL_WITHHOLD : ''}</span>
                                                            </td>
                                                        </tr>
                                                    )}
                                                    <tr className="a5-blank_row a5-bordered">
                                                        <td className="text-left">&nbsp;</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="a5-text-left a5-finalprice a5-p">{t.paymentAmount}</td>
                                                        <td className="a5-text-right a5-p">
                                                            <span>{index + 1 === totalPagesA.length ? templateData.TOTAL_PRICE : ''}</span>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            {showWaterMark && <div className="a5-cancel">ΑΚΥΡΟ</div>}
                            {((templateData.TRANSMISSION_FAILURE && (templateData.TRANSMISSION_FAILURE === "1" || templateData.TRANSMISSION_FAILURE === "2") && (templateData.MYDATADESTINATION === "Provider" || templateData.MYDATADESTINATION === "provider")) || (templateData.AUTHCODE && templateData.AUTHCODE !== "")) &&
                                <div>
                                    <span className="a5-sender_sign">www.primer.gr/search-invoice Provided by Primer Software P.C.</span><br/>
                                    <span className="a5-sender_sign">Άδεια ΥΠΑΗΕΣ: 2021_01_107Primer Software ΙΚΕ_001_ Primer MyData_V1_21012021</span>
                                </div>
                            }
                            {index + 1 === totalPagesA.length && (
                                <div className="a5-mydata_sign a5-p">
                                    {((templateData.TRANSMISSION_FAILURE && templateData.TRANSMISSION_FAILURE === "1" && (templateData.MYDATADESTINATION === "Provider" || templateData.MYDATADESTINATION === "provider")) || (templateData.TRANSMISSION_FAILURE && templateData.TRANSMISSION_FAILURE === "1" && templateData.AUTHCODE && templateData.AUTHCODE !== "")) &&
                                        <span className="a5-uid_sign">Απώλεια Διασύνδεσης Οντότητας - Παρόχου - Transmission Failure_1<br/></span>}
                                    {((templateData.TRANSMISSION_FAILURE && templateData.TRANSMISSION_FAILURE === "2" && (templateData.MYDATADESTINATION === "Provider" || templateData.MYDATADESTINATION === "provider")) || (templateData.TRANSMISSION_FAILURE && templateData.TRANSMISSION_FAILURE === "2" && templateData.AUTHCODE && templateData.AUTHCODE !== "")) &&
                                        <span className="a5-uid_sign">Απώλεια Διασύνδεσης Παρόχου - ΑΑΔΕ - Transmission Failure_2<br/></span>}
                                    {(templateData.TRANSMISSION_FAILURE === "3" && templateData.MYDATADESTINATION === "MyData") && (
                                        <span>Απώλεια Διασύνδεσης ERP – Α.Α.Δ.Ε. - Transmission Failure_3<br/></span>
                                    )}
                                    {templateData.UID && templateData.UID !== "" && templateData.AUTHCODE !== "" &&
                                        <span className="a5-uid_sign"> UID: {templateData.UID}</span>}
                                    {templateData.MARK && templateData.MARK !== "" &&
                                        <span> Μ.ΑΡ.Κ.: {templateData.MARK}</span>}
                                    {templateData.AUTHCODE && templateData.AUTHCODE !== "" &&
                                        <span className="a5-uid_sign"><br/> AUTHENTICATION CODE: {templateData.AUTHCODE}</span>}
                                </div>
                            )}
                            {(templateData?.dataType && templateData?.dataType === "editQuotations") && (
                                <div className={"mt-3 mb-2"}>
                                    <b>{t.nonTaxDocument}</b>
                                </div>
                            )}
                            {templateData.SHOW_SIGNATURE_FIELDS && (
                                <div style={{ display: 'flex', width: '100%', borderTop: '1px solid #ddd', marginTop: "20px" }}>
                                    <div style={{ ...columnStyle, borderLeft: '1px solid #ddd', borderRight: '1px solid #ddd' }}>
                                        {t.issue}
                                    </div>
                                    <div style={{...columnStyle, borderRight: '1px solid #ddd'}}>
                                        {t.receipt}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {(index + 1 !== totalPagesA.length && !firstCopy) && (
                    <div className="page-break"></div>
                )}
            </React.Fragment>
        )
    }

    return(
        <React.Fragment>
            {totalPagesA.length > 0 && totalPagesA.map((currentPage1, index) => {
                const compArr = [];
                if (doubleA5) {
                    compArr.push(
                        <React.Fragment>
                            {renderPage(index, false)}
                            {renderPage(index, true)}
                        </React.Fragment>
                    )
                } else {
                    compArr.push(renderPage(index))
                }
                if (index + 1 !== totalPagesA.length) compArr.push(<div className="page-break"></div>);
                return compArr;
            })}
        </React.Fragment>
    )
}

export default A5Template;
